stateProviders.push({
    name: "schoolside.settings.taxDocuments.taxWizard",
    url: "/taxWizard",
    templateUrl: "fast/submodules/schoolside/settings/taxDocuments/taxWizard/partials/taxWizard.html?v=" + versionNo,
    controller: "TaxWizardController",
    resolve: {
        school: function(SchoolModelService, authServiceFactory) {
            return SchoolModelService.get().length > 0
                ? SchoolModelService
                : SchoolModelService.resolveData(authServiceFactory.getAuth().schoolID);
        }
    }
});
